import * as React from 'react';
import * as Redux from 'redux';
import { BaseButton, IBaseButtonProps } from './base/base-button';
import { LoadingSpinner } from '../loading-spinner';

export interface ILoadingButton {
    id: string;
    customClasses?: string;
    buttonText: string;
    onClick?: (buttonId: string) => void;
    isLoading: boolean;
}


export class LoadingButton extends React.Component<ILoadingButton, any> {
    render() {
        const { id, buttonText, isLoading } = this.props;

        return (
            <button
                id={id}
                className={this.classNames}
                disabled={isLoading}
                onClick={() => this.props.onClick(id)}>
                <span className="button-text">{buttonText}</span>
                <LoadingSpinner loading={isLoading} />
            </button>
        );
    }


    get classNames() {
        let loadingClass = this.props.isLoading ? ' loading-button' : '';

        return this.props.customClasses + loadingClass;       
    }
}